interface CacheKeyArgs {
  userProfiles: never;
}

export function getUserProfilesSWRCacheKey<Key extends keyof CacheKeyArgs>(
  key: Key,
): string {
  switch (key) {
    case 'userProfiles': {
      return getUserProfilesCacheKey();
    }
    default: {
      throw new Error(`Invalid cache key: ${key}`);
    }
  }
}

const DOMAIN = 'user-profiles';

const getUserProfilesCacheKey = () => {
  return [DOMAIN, 'user-profiles'].join('/');
};
